import Component from '@galactic-advisors/component-loader';

const DEFAULTS = {};

export default class InitSentry extends Component {
  static selector = '[data-comp-init-sentry]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.userEmail = this.$container.dataset.email;
    this.userName = this.$container.dataset.userName;
    this.sentryDsn = this.$container.dataset.sentryDsn;
    this.sentryEnv = this.$container.dataset.sentryEnv;

    this.init();
  }

  init() {
    const user = {
      email: this.userEmail,
      name: this.userName,
    };

    window.sentryUser = JSON.stringify(user);
    window.sentryDsn = this.sentryDsn;
    window.sentryEnvironment = this.sentryEnv;
  }
}
